import React from "react";
import { AvatarApp } from "./AvatarApp";
import { IconApp } from "./IconApp";

export const EnterpriseCard = ({
    enterprise,
    active = false,
    forceColor = false,
    onlyLogo = false,
    onClick = null,
    
}) => {
    if (!enterprise) return null;

    return (
        <div
            className={`d-flex align-items-center ${onClick ? "py-2" : ""}`}
            style={{ cursor: onClick ? "pointer" : "default" }}
            onClick={onClick ? () => onClick(enterprise) : undefined}
        >
            <AvatarApp
                img={enterprise.uri}
                textToGenerateAvatar={enterprise.tiny_name}
                size={onClick ? 32 : 34}
            />

            {!onlyLogo && (
                <div className={`ml-2 ${forceColor ? "color_text_app" : ""}`}>
                    <div className={`text-uppercase font-weight-bold`}>
                        {enterprise.tiny_name}
                    </div>
                    <div className={`small`}>
                        {enterprise.rfc || "RFC no registrado"}
                    </div>
                </div>
            )}

            {active && (
                <IconApp
                    iconClassName="fa fa-check ml-auto label"
                    fontSize="14px"
                />
            )}
        </div>
    );
};
